import React, { useState } from 'react'
import { FaMicrochip } from 'react-icons/fa'
import '../Tools.css'

// Resistor color code data
const colorCodes = {
    black: { value: 0, multiplier: 1, tolerance: null, color: '#000000' },
    brown: { value: 1, multiplier: 10, tolerance: 1, color: '#8B4513' },
    red: { value: 2, multiplier: 100, tolerance: 2, color: '#FF0000' },
    orange: { value: 3, multiplier: 1000, tolerance: null, color: '#FFA500' },
    yellow: { value: 4, multiplier: 10000, tolerance: null, color: '#FFFF00' },
    green: { value: 5, multiplier: 100000, tolerance: 0.5, color: '#008000' },
    blue: { value: 6, multiplier: 1000000, tolerance: 0.25, color: '#0000FF' },
    violet: { value: 7, multiplier: 10000000, tolerance: 0.1, color: '#EE82EE' },
    gray: { value: 8, multiplier: 100000000, tolerance: 0.05, color: '#808080' },
    white: { value: 9, multiplier: 1000000000, tolerance: null, color: '#FFFFFF' },
    gold: { value: null, multiplier: 0.1, tolerance: 5, color: '#FFD700' },
    silver: { value: null, multiplier: 0.01, tolerance: 10, color: '#C0C0C0' }
}

const colorNames = ['black', 'brown', 'red', 'orange', 'yellow', 'green', 'blue', 'violet', 'gray', 'white', 'gold', 'silver']
const digitColors = colorNames.filter(c => colorCodes[c].value !== null)
const multiplierColors = colorNames
const toleranceColors = colorNames.filter(c => colorCodes[c].tolerance !== null)

const ResistorCalculator = () => {
    const [band1, setBand1] = useState('brown')
    const [band2, setBand2] = useState('black')
    const [band3, setBand3] = useState('red')
    const [tolerance, setTolerance] = useState('gold')

    const calculateResistance = () => {
        const digit1 = colorCodes[band1].value
        const digit2 = colorCodes[band2].value
        const multiplier = colorCodes[band3].multiplier
        const value = (digit1 * 10 + digit2) * multiplier
        return value
    }

    const formatResistance = (value) => {
        if (value >= 1000000) {
            return `${(value / 1000000).toFixed(value % 1000000 === 0 ? 0 : 2)} M\u03A9`
        } else if (value >= 1000) {
            return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 2)} k\u03A9`
        }
        return `${value} \u03A9`
    }

    const resistance = calculateResistance()
    const toleranceValue = colorCodes[tolerance].tolerance

    return (
        <div className="tool-calculator">
            <h3><FaMicrochip /> Resistor Color Code Calculator</h3>
            <p className="tool-description">Select the colors of the 4-band resistor to calculate its value.</p>

            <div className="resistor-display">
                <div className="resistor-body">
                    <div className="resistor-band" style={{ backgroundColor: colorCodes[band1].color }}></div>
                    <div className="resistor-band" style={{ backgroundColor: colorCodes[band2].color }}></div>
                    <div className="resistor-band" style={{ backgroundColor: colorCodes[band3].color }}></div>
                    <div className="resistor-band tolerance-band" style={{ backgroundColor: colorCodes[tolerance].color }}></div>
                </div>
            </div>

            <div className="color-selectors">
                <div className="color-selector">
                    <label>Band 1 (1st Digit)</label>
                    <select value={band1} onChange={(e) => setBand1(e.target.value)}>
                        {digitColors.map(color => (
                            <option key={color} value={color}>{color.charAt(0).toUpperCase() + color.slice(1)} ({colorCodes[color].value})</option>
                        ))}
                    </select>
                </div>
                <div className="color-selector">
                    <label>Band 2 (2nd Digit)</label>
                    <select value={band2} onChange={(e) => setBand2(e.target.value)}>
                        {digitColors.map(color => (
                            <option key={color} value={color}>{color.charAt(0).toUpperCase() + color.slice(1)} ({colorCodes[color].value})</option>
                        ))}
                    </select>
                </div>
                <div className="color-selector">
                    <label>Band 3 (Multiplier)</label>
                    <select value={band3} onChange={(e) => setBand3(e.target.value)}>
                        {multiplierColors.map(color => (
                            <option key={color} value={color}>{color.charAt(0).toUpperCase() + color.slice(1)} (&times;{colorCodes[color].multiplier})</option>
                        ))}
                    </select>
                </div>
                <div className="color-selector">
                    <label>Band 4 (Tolerance)</label>
                    <select value={tolerance} onChange={(e) => setTolerance(e.target.value)}>
                        {toleranceColors.map(color => (
                            <option key={color} value={color}>{color.charAt(0).toUpperCase() + color.slice(1)} (&plusmn;{colorCodes[color].tolerance}%)</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="result-box">
                <span className="result-label">Resistance:</span>
                <span className="result-value">{formatResistance(resistance)} &plusmn;{toleranceValue}%</span>
            </div>
        </div>
    )
}

export default ResistorCalculator
